import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-summary-dialog',
  templateUrl: './summary-dialog.component.html',
  styleUrls: ['./summary-dialog.component.scss']
})
export class SummaryDialogComponent implements OnInit 
{
  constructor(@Inject(MAT_DIALOG_DATA) public data: {title: string, detail:string, accept:string}) { }

  ngOnInit(): void {
  }

}
